import { render } from "./Pontaj.vue?vue&type=template&id=dfd0a2a8&scoped=true&ts=true"
import script from "./Pontaj.vue?vue&type=script&lang=ts"
export * from "./Pontaj.vue?vue&type=script&lang=ts"

import "./Pontaj.vue?vue&type=style&index=0&id=dfd0a2a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd0a2a8"]])

export default __exports__